//资源产销详情
import request from '@/utils/request';
export function getResoceDetail(data) {
  return request({
    url: '/data/resource_desc_list',
    method: 'get',
    params: data
  });
}